import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GroupSelectorDTO } from 'src/AngularJS/Reusables/group-selector.models';
import { ModuleManager } from 'src/shared/models/module-manager';
import SlideoutSettingsManager from 'src/shared/models/slideout-settings-manager';

@Component({
    selector: 'cxone-evaluation-coaching-trend-settings',
    templateUrl: './cxone-evaluation-coaching-trend-settings.component.html',
    styleUrls: ['./cxone-evaluation-coaching-trend-settings.component.scss']
})
export class CXoneEvaluationCoachingTrendSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() settingsManager: SlideoutSettingsManager;
    public selectedGroupsDto: GroupSelectorDTO;

    constructor(
        private changeDetector: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.moduleManager.slideoutSettingsManager.subscribe(manager => {
            this.settingsManager = manager;
            this.changeDetector.detectChanges();
        });
        this.moduleManager.customSettingsAdded = true;
    }
}
